var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 47,
    viewBox: "0 0 41 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9701 11.3654L26.429 19.3343L34.189 14.8245L19.8316 6.99762L11.9701 11.3654Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04431 15.0744V31.1144L19.8994 38.9185V23.1285L6.04431 15.0744Z",
    fill: "url(#paint0_linear_61_11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04431 31.1144L0 34.6927L19.8994 46.257V38.9186L6.04431 31.1144Z",
    fill: "url(#paint1_linear_61_11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04431 31.1144V15.0744L0 11.5642V34.6927L6.04431 31.1144Z",
    fill: "url(#paint2_linear_61_11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6051 19.8114L19.8994 23.1285V39.7251V46.257L26.4347 42.4628L26.429 19.3343L25.6051 19.8114Z",
    fill: "#6338C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.189 14.8245L40.6227 11.0815L19.8994 0L0 11.5642L19.8994 23.1285L26.429 19.3343L11.9701 11.3654L19.8316 6.99761L34.189 14.8245Z",
    fill: "#6338C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6227 11.0815L26.4234 19.3286L26.429 19.3343V42.4571L40.6227 34.2099V11.0815Z",
    fill: "#E0D7F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_11",
    x1: 12.969,
    y1: 33.6192,
    x2: 12.969,
    y2: 9.76939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#15203D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15203D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_11",
    x1: 9.24424,
    y1: 41.4518,
    x2: 14.167,
    y2: 34.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6338C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2277"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_11",
    x1: 3.01933,
    y1: 34.6927,
    x2: 3.01933,
    y2: 11.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1AFE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLogo);
export default __webpack_public_path__ + "static/media/Store_logo.fe40d952d64b5d5412b29a4ded53f9e5.svg";
export { ForwardRef as ReactComponent };